module.exports = __webpack_public_path__ + "static/media/nizwa.78fb97a1.jpg";